import React from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";
import { NavLink, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
const Footer = () => {
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "HOME" },
    { path: "/about-us", label: "ABOUT US" },
    { path: "/contact-us", label: "CONTACT US" },
    { path: "/terms-ans-conditions", label: "TERMS AND CONDITION" },
    { path: "/privacy-policy", label: "PRIVACY POLICY" },
  ];

  const socialIcons = [
    {
      img: "/assets/images/social_icons/fb.png",
      link: "https://www.facebook.com/profile.php?id=61578144719709",
    },
    {
      img: "/assets/images/social_icons/insta.png",
      link: "https://www.instagram.com/my_mds_india/",
    },
    {
      img: "/assets/images/social_icons/yt.png",
      link: "https://www.youtube.com/@My_MDS_India",
    },
     {
      img: "/assets/images/social_icons/tw.png",
      link: "https://x.com/My_MDS_India",
    },
  ];

  return (
    <>
      <div className="container">
        <div className="top_section_holder">
          <div className="text_holder">
            <h4>Learning to Drive Made Easy</h4>
            <p>Available on both platforms – simple, fast, and convenient.</p>
          </div>

          <div className="play_store_img_holder">
            <Link to={"https://play.google.com/store/apps/details?id=com.my_mds&pcampaignid=web_share"} target='_blank'>
              <div className="img_holder">
                <img
                  src="/assets/images/play_store/google_play.png"
                  alt="google play"
                  className="play_store"
                />
              </div>
            </Link>
            <Link to={"https://apps.apple.com/us/app/my-mds/id6761702700"} target='_blank'>
              <div className="img_holder">
                <img
                  src="/assets/images/play_store/app_store.png"
                  alt="play store"
                  className="play_store"
                />
              </div>
            </Link>
          </div>
        </div>
      </div>

      <section className="Footer ">
        <div className="container">
          <div className="footer_link_div">
            <div className="col_div">
              <Nav>
                <div className="first_nav_div">
                  {navLinks.map((link, index) => (
                    <Nav.Item key={index}>
                      <NavLink
                        as={Link}
                        to={link.path}
                        className={
                          location.pathname === link.path ? "active" : ""
                        }
                      >
                        {link.label}
                      </NavLink>
                    </Nav.Item>
                  ))}
                </div>
              </Nav>
            </div>

            <div className="bottom_div">
              <div className="left_side">
                <div className="contact_div">
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faEnvelope} className="icon_class" />
                  </div>
                  <Link
                    to={"https://mail.google.com/mail/?view=cm&fs=1&to=admin@mymds.co.in"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="text footer_text">admin@mymds.co.in</p>
                  </Link>

                </div>

                <div className="contact_div">
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faPhone} className="icon_class" />
                  </div>
                  <Link to={"tel:+919876543210"} target='_blank'>
                    <p className="text footer_text">+91 9145566955</p>
                  </Link>
                </div>
              </div>

              <div className="right_side">
                <p className="footer_text">Follow us on:</p>

                <div className="social_icons_holder">
                  {socialIcons.map((item, index) => (
                    <div className="img_holder">
                      <a
                        key={index}
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="img_holder"
                      >
                        <img
                          src={item.img}
                          alt={`social-icon-${index}`}
                          className="icon_img"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="rights_div mx-auto">
          <p className="inner_text">

            ©2025 <Link to={"https://mymds.co.in/"} target="_blank"><b>My MDS</b></Link> All Rights Reserved | Developed by <Link to={"https://profcymaglobal.com/"} target="_blank"><b>Profcyma Solutions Pvt Ltd</b></Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
